module.exports = __webpack_public_path__ + "static/media/rs.e3e85993.svg";